import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import config from "../utilities/config";
import { Link,useBlocker,useNavigationType } from "react-router-dom";
import { Toast } from "../../src/components/Atoms/Toast";
import { useProductListAPI } from "../hooks/useProductListAPI";
import { useSequentialAPI } from "../hooks/useSequentialAPI";
import {
  isMobile,
  isTablet,
  isBrowser,
  isSmartTV,
  deviceType,
  osName,
} from "react-device-detect";

import { CartItemAddToWishList } from "../utilities/api";
import constants from "../utilities/constants";
import { getAuthModalType } from "../redux/action/authAction";
import { Helmet } from "react-helmet";
import {
  fetchSEOData,
  getPriceRangeMinMax,
  intProductListItem,
  product_list_filter,
  product_list_item,
  resetSelectedFilters,
  updateSelectedFilters,
  setPaginationOffset,
  resetPagination,
  updateCurrentPriceRange,
  resetActiveRequests,
} from "../redux/action/productAction";

import {
  getImage,
  formatCurrencywithamount,
  findCategoryByValue,
  filterSortFromURl,
  filterSortByArrayBasedOnUrl,
  changePriceValue,
} from "../utilities/helper";

import { Range } from "react-range";
import { isEmptyArray } from "formik";
import Modal from "react-modal";
// import Pagination from "../components/Pagenation";
import ReactPaginate from "react-paginate";
import {
  addwishlistwithoutlogin,
  addWishlistWithLogin,
  productListIsLikedChange,
  getPersionalData,
  removewishlistfromstore,
  productListIsLikedChanged,
} from "../redux/action/myAccountAction";
import isEqual from "lodash.isequal";
import { ACTION_TYPE } from "../redux/action/type";
import { useNavigate } from "react-router-dom";

function ProductList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { callAPI, resetTracker } = useProductListAPI();
  const { executeSequence, cancelSequence } = useSequentialAPI();

  const url = new URL(window.location.href);
  const params = url.searchParams;

  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    // Check if current URL is a category page (not home page) and has no query params
    const isProductCategoryPage = window.location.pathname !== constants.ADDITIONAL_PATH && 
                                 window.location.pathname !== '/' && 
                                 window.location.pathname !== constants.ADDITIONAL_PATH + '/';
    
    if (isProductCategoryPage && !params.has("sort")) {
      // Keep the same URL path but add the required query parameters
      navigate(
        `${window.location.pathname}?sort=New%20to%20Stylori&startprice=0&endprice=0`,
        { replace: true }
      );
      return;
    }
    
    // Handle home page without sort parameter
    if (!params.has("sort") && !isProductCategoryPage) {
      navigate(
        constants.ADDITIONAL_PATH + constants.CLEAR_FILTER_REDIRECT_PATH,
        { replace: false }
      );
    } else {
      // Fix URL encoding - convert + to %20 for sort parameter
      const sortParam = params.get('sort');
      if (sortParam && sortParam.includes('+')) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('sort', sortParam.replace(/\+/g, ' '));
        window.history.replaceState({}, '', currentUrl.toString());
      }
    }
  }, []);
  const {
    productListitemsResponseSuccess,
    productMaxPrice,
    productMinPrice,
    currentPriceRange,
    productListitemsResponesLoading,
    selectedFiltersNew,
    currentOffset,
    currentPage
  } = useSelector((state) => state.productFilterListitemsReducer);
  
  const { selectedcountrySuccess, dailyMetalPriceSuccess } = useSelector(
    (state) => state.homeReducer
  );
  
  //SEO Data Reducer
  const { getSEODataResponseSuccess } = useSelector(
    (state) => state.getSEODataReducer
  );
  
  const { productListResponseSuccess, productListResponesLoading } =
    useSelector((state) => state.productFilterListReducer);
  
  const [allattriButeValue, setAllattriButeValue] = useState(null);
  const [offSet, SetOffset] = useState(0);
  const [apiTotalCount, setAPITotalCount] = useState(0);
  const limit = 36; // Items per page
  const [itemOffset, setItemOffset] = useState(0);
  
  const prevSeoNodesRef = useRef(null);
  
  // API call management
  const [apiStep, setApiStep] = useState(0);
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  
  // Helper function to clean API payload and remove conflicting price objects
  const cleanApiPayload = (payload) => {
    const cleanedPayload = { ...payload };
    if (cleanedPayload.price) {
      delete cleanedPayload.price;
    }
    return cleanedPayload;
  };
  useEffect(() => {
  // When the route (URL) changes — clear applied filters
  dispatch(resetSelectedFilters()); // clear filters from redux
  
  // Get sort parameter from URL
  const urlParams = new URLSearchParams(window.location.search);
  const sortParam = urlParams.get('sort');
  const decodedSort = sortParam ? decodeURIComponent(sortParam) : "New to Stylori";
  
  // Reset local selectedFilters and populate with SEO data if available
  const newFilters = {
    Collection: [],
    Theme: [],
    Occasion: [],
    Style: [],
    Finish: [],
    "Product Type": [],
    "Sort By": decodedSort,
  };
  
  // Add SEO data to filters if available
  if (allattriButeValue) {
    const excludeTerms = ['silver', 'jewellery', 'jewelry'];
    allattriButeValue.forEach((item) => {
      if (item.attributeName && item.attributeValue && item.attributeName !== "Sort By") {
        if (!excludeTerms.includes(item.attributeValue.toLowerCase())) {
          if (!newFilters[item.attributeName]) {
            newFilters[item.attributeName] = [];
          }
          if (!newFilters[item.attributeName].includes(item.attributeValue)) {
            newFilters[item.attributeName].push(item.attributeValue);
          }
        }
      }
    });
  }
  
  setSelectedFilters(newFilters);
}, [window.location.href, allattriButeValue]);

  
  // Reset pagination when URL path changes (not query params)
  useEffect(() => {
    const newPath = window.location.pathname;
    if (currentPath !== newPath) {
      dispatch(resetPagination());
      SetOffset(0);
      setItemOffset(0);
      setCurrentPath(newPath);
    }
  }, [window.location.pathname, currentPath]);
  const [filterListData, setFilterListData] = useState(null);
  const [urlPriceParams, setUrlPriceParams] = useState({ startPrice: null, endPrice: null });
  const [isDirectUrlLoad, setIsDirectUrlLoad] = useState(false);
  
  // Parse URL parameters on mount and initialize state
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlStartPrice = urlParams.get('startprice');
    const urlEndPrice = urlParams.get('endprice');
    const sortParam = urlParams.get('sort');
    const pageParam = urlParams.get('page');
    
    // Set URL price parameters
    if (urlStartPrice && urlEndPrice) {
      const startPrice = parseFloat(urlStartPrice);
      const endPrice = parseFloat(urlEndPrice);
      setUrlPriceParams({ startPrice, endPrice });
      
      // Only mark as user adjusted if not default (0,0)
      if (!(urlStartPrice === '0' && urlEndPrice === '0')) {
        setUserAdjustedPrice(true);
        setFinalPriceRange([urlStartPrice, urlEndPrice]);
        dispatch(updateCurrentPriceRange([startPrice, endPrice]));
      }
    }
    
    // Set page parameter
    if (pageParam) {
      const pageNumber = parseInt(pageParam);
      if (pageNumber > 1) {
        const pageOffset = (pageNumber - 1) * limit;
        SetOffset(pageOffset);
        setItemOffset(pageNumber - 1);
        dispatch(setPaginationOffset(pageOffset, pageNumber - 1));
      }
    }
    
    // Set sort parameter and mark as direct URL load
    if (sortParam) {
      // Handle both + and %20 encoding for spaces
      const decodedSort = decodeURIComponent(sortParam);
      setSelectedValue(decodedSort);
      setSelectedFilters(prev => ({ ...prev, "Sort By": decodedSort }));
      setIsDirectUrlLoad(true);
    }
  }, []);
  
  // Update selectedValue when URL changes
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sortParam = urlParams.get('sort');
    if (sortParam) {
      const decodedSort = decodeURIComponent(sortParam);
      setSelectedValue(decodedSort);
      setSelectedFilters(prev => ({ ...prev, "Sort By": decodedSort }));
    }
  }, [window.location.search]);
  
  // Step 1: SEO data available → trigger price range API
  useEffect(() => {
    const seoNodes = getSEODataResponseSuccess?.data?.allSeoUrlPriorities?.nodes;
    
    if (seoNodes && seoNodes.length > 0 && !isEqual(prevSeoNodesRef.current, seoNodes)) {
      config.logGeneral && console.log('Step 1: SEO GraphQL complete, starting price range API:', seoNodes);
      prevSeoNodesRef.current = seoNodes;
      setAllattriButeValue(seoNodes);
      setApiStep(1);
      
      // Build SEO attributes for price range API
      const seoAttributes = {};
      seoNodes.forEach((item) => {
        if (item.attributeName && item.attributeValue) {
          const attrName = item.attributeName;
          switch (attrName) {
            case 'Product Type':
              seoAttributes.producttype = item.attributeValue;
              break;
            case 'Material':
              seoAttributes.material = item.attributeValue;
              break;
            case 'Category':
              seoAttributes.category = item.attributeValue;
              break;
            default:
              seoAttributes[attrName.toLowerCase().replace(/\s+/g, '')] = item.attributeValue;
          }
        }
      });
      
      if (!seoAttributes.material) seoAttributes.material = 'Silver';
      if (!seoAttributes.category) seoAttributes.category = 'Jewellery';
      
      config.logGeneral && console.log('Step 1: Calling getPriceRangeMinMax with:', seoAttributes);
      dispatch(getPriceRangeMinMax(seoAttributes));
    }
  }, [getSEODataResponseSuccess, dispatch]);
  
  // Step 2: Price range complete OR timeout → trigger filter list API
  useEffect(() => {
    if (apiStep === 1 && allattriButeValue) {
      // Proceed immediately without waiting for price range
      setApiStep(2);
      config.logGeneral && console.log('Step 2: Calling filter API with:', allattriButeValue);
      dispatch(product_list_filter(allattriButeValue));
    }
  }, [apiStep, allattriButeValue, dispatch]);
  
  // Step 3: Filter list complete → trigger product list API
  const productApiFetched = useRef(false);
  useEffect(() => {
    if (apiStep === 2 && productListResponseSuccess && Object.keys(productListResponseSuccess).length > 0 && !productListResponesLoading && allattriButeValue && !productApiFetched.current) {
      productApiFetched.current = true;
      setApiStep(3);
      setFilterListData(productListResponseSuccess);
      config.logGeneral && console.log('Step 3: Filter list complete, calling fetchproducts API');
      
      const seoAttributes = {};
      allattriButeValue.forEach((item) => {
        if (item.attributeName && item.attributeValue) {
          const attrName = item.attributeName;
          switch (attrName) {
            case 'Product Type':
              seoAttributes.producttype = item.attributeValue;
              break;
            case 'Material':
              seoAttributes.material = item.attributeValue;
              break;
            case 'Category':
              seoAttributes.category = item.attributeValue;
              break;
            default:
              seoAttributes[attrName.toLowerCase().replace(/\s+/g, '')] = item.attributeValue;
          }
        }
      });
      
      if (!seoAttributes.material) seoAttributes.material = 'Silver';
      if (!seoAttributes.category) seoAttributes.category = 'Jewellery';
      
      // Add URL price parameters
      const startPrice = parseInt(params.get('startprice') || '0');
      const endPrice = parseInt(params.get('endprice') || '0');
      if (startPrice > 0 || endPrice > 0) {
        seoAttributes.price = {
          min_price: startPrice,
          max_price: endPrice
        };
        config.logGeneral && console.log('Step 3: Adding URL price params:', { price: { min_price: startPrice, max_price: endPrice } });
      }
      
      // Add sort parameter from URL
      const sortParam = params.get('sort');
      if (sortParam) {
        seoAttributes['Sort By'] = decodeURIComponent(sortParam);
        config.logGeneral && console.log('Step 3: Adding sort param:', sortParam);
      }
      
      dispatch(product_list_item(seoAttributes, offSet));
    }
  }, [apiStep, productListResponseSuccess, productListResponesLoading, allattriButeValue, dispatch, offSet, params]);
  

  
  // Initialize price range from URL or API response
  useEffect(() => {
    if (selectedcountrySuccess && productMinPrice !== null && productMaxPrice !== null) {
      const urlParams = new URLSearchParams(window.location.search);
      const urlStartPrice = urlParams.get('startprice');
      const urlEndPrice = urlParams.get('endprice');
      
      if (urlStartPrice && urlEndPrice && (urlStartPrice !== "0" || urlEndPrice !== "0")) {
        const startPrice = parseFloat(urlStartPrice);
        const endPrice = parseFloat(urlEndPrice);
        if (!isNaN(startPrice) && !isNaN(endPrice)) {
          setUserAdjustedPrice(true);
          dispatch(updateCurrentPriceRange([startPrice, endPrice]));
          setFinalPriceRange([`${startPrice}`, `${endPrice}`]);
        }
      } else if (!userAdjustedPrice) {
        dispatch(updateCurrentPriceRange([productMinPrice, productMaxPrice]));
        setFinalPriceRange([`${productMinPrice}`, `${productMaxPrice}`]);
      }
    }
  }, [selectedcountrySuccess, productMinPrice, productMaxPrice]);

  const [getSeoData, setSeoData] = useState(null);
  const [productsToDisplay, setProductsToDisplay] = useState([]);  
  const [likedProducts, setLikedProducts] = useState({});
  const [stableProducts, setStableProducts] = useState([]);
  const [productsLoaded, setProductsLoaded] = useState(false);
  const [Category, setCategory] = useState([]);  
  const [selectedFilters, setSelectedFilters] = useState({
    Collection: [],
    Theme: [],
    Occasion: [],
    Style: [],
    Finish: [],
    "Product Type": [],
    "Sort By": null,
  });
  const hasRunOnce = useRef(false);
  const productListLoading = useRef(false);
  const productList = useRef(null);
  const prevValuesFilter = useRef(null);
  const initialApiCalled = useRef(false);


  const [filters, setfilters] = useState([]);
  const [isMobileFilter, setIsMobileFilter] = useState(false);
  const [finalPriceRange, setFinalPriceRange] = useState(["0", "200000"]);
  const [selectedValue, setSelectedValue] = useState("Sort By");
  const [metatitle, setmetatitle] = useState("");
  const [metadescription, setmetadescription] = useState("");
  const [metakeyword, setmetakeyword] = useState("");
  const [metaseotext, setmetaseotext] = useState("");
  const [seourl, setseourl] = useState("");
  const [title, settitle] = useState("");
  const clear = "clear";
  const [userAdjustedPrice, setUserAdjustedPrice] = useState(false);
  const [hoveredProductId, setHoveredProductId] = useState(null);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  const prevSeoDataRef = useRef(null);

  // Stable product display with proper count sync
  useEffect(() => {
    if (productListitemsResponseSuccess?.data?.allProductLists && !productListitemsResponesLoading) {
      const products = productListitemsResponseSuccess.data.allProductLists;
      const totalCount = productListitemsResponseSuccess?.data?.totalCount || 0;
      const fetchMinPrice = productListitemsResponseSuccess?.data?.minPrice;
      const fetchMaxPrice = productListitemsResponseSuccess?.data?.maxPrice;
      
      // Update price range if fetchproducts has min/max values
      if (fetchMinPrice !== undefined && fetchMaxPrice !== undefined) {
        config.logGeneral && console.log('Updating price range from fetchproducts:', { fetchMinPrice, fetchMaxPrice });
        
        dispatch({
          type: 'UPDATE_PRODUCT_LIST_PRICE_RANGE_SUCCESS',
          payload: {
            productMinPrice: fetchMinPrice,
            productMaxPrice: fetchMaxPrice,
          },
        });
        
        // Use actual API values without modification
        dispatch({
          type: 'UPDATE_CURRENT_PRICE_RANGE',
          payload: [fetchMinPrice, fetchMaxPrice],
        });
      }
      
      // Ensure count matches products length for consistency
      if (products.length > 0 || totalCount === 0) {
        setProductsToDisplay(products);
        setStableProducts(products);
        setProductsLoaded(true);
        setAPITotalCount(totalCount);
      }
    }
  }, [productListitemsResponseSuccess, productListitemsResponesLoading, dispatch]);

  // Reset state when URL changes
  useEffect(() => {
    resetTracker();
    resetActiveRequests();
    cancelSequence();
    setProductsToDisplay([]);
    setProductsLoaded(false);
    setIsStableDataLoaded(false);
    setIsUserAction(false);
    setfilters([]);
    setSelectedFilters({
      Collection: [],
      Theme: [],
      Occasion: [],
      Style: [],
      Finish: [],
      "Product Type": [],
      "Sort By": null,
    });
    setFilterListData(null);
    priceApiCallMade.current = false;
    productApiFetched.current = false;
    setApiStep(0);
    setUrlPriceParams({ startPrice: null, endPrice: null });
    // Reset price range so slider uses new min/max values
    dispatch({ type: 'RESET_CURRENT_PRICE_RANGE' });
    setIsDirectUrlLoad(false);
  }, [window.location.href, resetTracker]);



  // Loading state management
  const [isStableDataLoaded, setIsStableDataLoaded] = useState(false);
  const [isUserAction, setIsUserAction] = useState(false);
  
  // Check if data is loaded (simplified)
  const isDataFullyLoaded = (productsLoaded || productsToDisplay.length > 0) && 
    !productListitemsResponesLoading;
    
  // Check if APIs are complete but no products found
  const isNoProductsFound = isDataFullyLoaded && productsToDisplay.length === 0;
  
  // Reset user action flag when products are loaded
  useEffect(() => {
    if ((isUserAction || isDirectUrlLoad) && productsLoaded && !productListitemsResponesLoading) {
      setIsUserAction(false);
      setIsDirectUrlLoad(false);
    }
  }, [productsLoaded, productListitemsResponesLoading, isUserAction, isDirectUrlLoad]);
  
  // Show data immediately when loaded
  useEffect(() => {
    if (isDataFullyLoaded) {
      setIsStableDataLoaded(true);
    } else {
      setIsStableDataLoaded(false);
    }
  }, [isDataFullyLoaded]);

  const handlePriceChange = (values) => {
    SetOffset(0);
    setItemOffset(0);
    dispatch(updateCurrentPriceRange(values));
  };
  const handleFinalPriceChange = (values) => {
    setIsUserAction(true);
    setUserAdjustedPrice(true);
    dispatch(resetPagination());
    SetOffset(0);
    setItemOffset(0);
    
    setFinalPriceRange(values);
    
    dispatch(updateSelectedFilters(null, null, values));
    
    const startPrice = parseFloat(values[0]);
    const endPrice = parseFloat(values[1]);
    
    if (!isNaN(startPrice) && !isNaN(endPrice) && startPrice <= endPrice) {
      const currentUrl = new URL(window.location.href);
      const sortParam = currentUrl.searchParams.get('sort');
      
      // Build exact URL format
      const baseUrl = `${currentUrl.origin}${currentUrl.pathname}`;
      let finalUrl = `${baseUrl}?sort=${encodeURIComponent(sortParam || 'Price Low to High')}&startprice=${values[0]}&endprice=${values[1]}`;
      
      window.history.replaceState({}, '', finalUrl);
      
      // Build payload with SEO attributes and price range
      const seoAttributes = {};
      if (allattriButeValue) {
        allattriButeValue.forEach((item) => {
          if (item.attributeName && item.attributeValue) {
            const attrName = item.attributeName;
            switch (attrName) {
              case 'Product Type':
                seoAttributes.producttype = item.attributeValue;
                break;
              case 'Material':
                seoAttributes.material = item.attributeValue;
                break;
              case 'Category':
                seoAttributes.category = item.attributeValue;
                break;
              default:
                seoAttributes[attrName.toLowerCase().replace(/\s+/g, '')] = item.attributeValue;
            }
          }
        });
      }
      
      if (!seoAttributes.material) seoAttributes.material = 'Silver';
      if (!seoAttributes.category) seoAttributes.category = 'Jewellery';
      
      // Preserve current filters and add price range
      const finalPayload = {
        ...cleanApiPayload(selectedFiltersNew),
        ...seoAttributes,
        price: {
          min_price: startPrice,
          max_price: endPrice
        }
      };
      
      // Call fetchproducts API to get filtered products
      dispatch(product_list_item(finalPayload, 0));
    }
  };
  const [expandedCategories, setExpandedCategories] = useState([]);

  const navigationType = useNavigationType();
  // const filterList = [
  //   "Collection",
  //   "Theme",
  //   "Occasion",
  //   "Style",
  //   "Finish",
  //   "Product Type",
  //   "Sort By",
  // ];

  const filterList=[
"Product Type",
"Occasion",
"Collection",
"Style","Theme","Finish","Sort By"
]
  // Handle filter change
  // const handleFilterChange = (category, value) => {
  //   SetOffset(0);
  //   setItemOffset(0);

  //   setSelectedFilters((prevState) => {
  //     // If the same item is selected, unselect it
  //     const newSelection = prevState[category] === value ? null : value;
  //     return { ...prevState, [category]: newSelection };
  //   });
  //   productListLoading.current = false;
  // };

  // Helper function to convert filter value to SEO URL format
  const convertToSeoUrl = (value) => {
    return value.toLowerCase().replace(/\s+/g, '+');
  };

  // Helper function to get SEO URL for filter value
  const getSeoUrlForFilter = (filterCategory, filterValue) => {
    // Check if we have filter data with seourl
    if (filters && filters[filterCategory]) {
      const filterOption = filters[filterCategory].find(option => option.name === filterValue);
      config.logGeneral && console.log(`Looking for ${filterValue} in ${filterCategory}:`, filterOption);
      
      // Check multiple possible property names for SEO URL
      let seoUrlValue = null;
      if (filterOption) {
        seoUrlValue = filterOption.seourl || filterOption.seoUrl || filterOption.seo_url || filterOption.url;
        config.logGeneral && console.log(`SEO URL value found:`, seoUrlValue);
      }
      
      if (seoUrlValue) {
        // Use the full seourl value, don't split it
        config.logGeneral && console.log(`Using SEO URL: ${seoUrlValue} for ${filterValue}`);
        return seoUrlValue;
      }
    }
    // Fallback to converting filter value
    const fallbackUrl = convertToSeoUrl(filterValue);
    config.logGeneral && console.log(`Using fallback URL: ${fallbackUrl} for ${filterValue}`);
    return fallbackUrl;
  };

  // Helper function to update URL with filter values
  const updateUrlWithFilters = (updatedFilters) => {
    const currentUrl = new URL(window.location.href);
    const pathParts = currentUrl.pathname.split('/');
    const basePath = pathParts.slice(0, -1).join('/');
    
    // Remove page parameter when filters change
    currentUrl.searchParams.delete('page');
    
    // Collect ONLY current filter values from updatedFilters (no SEO attributes)
    const allFilterParts = [];
    
    // Add current filter values from updatedFilters only
    Object.entries(updatedFilters).forEach(([filterCategory, filterValues]) => {
      if (filterCategory !== "Sort By" && filterValues) {
        if (Array.isArray(filterValues)) {
          filterValues.forEach(filterValue => {
            if (filterValue && filterValue !== "") {
              const seoUrl = getSeoUrlForFilter(filterCategory, filterValue);
              if (!allFilterParts.includes(seoUrl)) {
                allFilterParts.push(seoUrl);
              }
            }
          });
        } else if (filterValues !== "") {
          const seoUrl = getSeoUrlForFilter(filterCategory, filterValues);
          if (!allFilterParts.includes(seoUrl)) {
            allFilterParts.push(seoUrl);
          }
        }
      }
    });
    
    // Build new URL path - always include base 'silver-jewellery'
    const baseUrl = 'silver-jewellery';
    const newPath = allFilterParts.length > 0 
      ? `${basePath}/${baseUrl}-${allFilterParts.join('-')}` 
      : `${basePath}/${baseUrl}`;
    let newUrl = `${newPath}${currentUrl.search}`;
    
    // Preserve sort parameter encoding (%20 instead of +)
    const sortParam = currentUrl.searchParams.get('sort');
    if (sortParam) {
      newUrl = newUrl.replace(/sort=[^&]+/, `sort=${encodeURIComponent(sortParam)}`);
    }
    
    // Update URL without page reload
    window.history.replaceState({}, '', newUrl);
  };

  const handleFilterChange = useCallback((category=null, value=null) => {
    setIsUserAction(true);
    dispatch(resetPagination());
    SetOffset(0);
    setItemOffset(0);

    setSelectedFilters((prevState) => {
      let updatedFilters;
      if (category === "Sort By") {
        updatedFilters = { ...prevState, [category]: value };
      } else {
        const currentValues = Array.isArray(prevState[category]) ? prevState[category] : [];
        const valueExists = currentValues.includes(value);
        const updatedValues = valueExists
          ? currentValues.filter((v) => v !== value)
          : [...currentValues, value];
        updatedFilters = { ...prevState, [category]: updatedValues };
      }
      
      // Update URL with new filters (only for non-Sort By filters)
      if (category !== "Sort By") {
        updateUrlWithFilters(updatedFilters);
      } else {
        // Update sort parameter in URL with proper encoding (%20 instead of +)
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('page');
        const urlString = currentUrl.toString();
        const finalUrl = urlString.replace(/sort=[^&]*/, `sort=${encodeURIComponent(value)}`);
        window.history.replaceState({}, '', finalUrl);
      }
      
      const seoAttributes = {};
      if (allattriButeValue) {
        allattriButeValue.forEach((item) => {
          if (item.attributeName && item.attributeValue) {
            if (item.attributeName === 'Category' || item.attributeName === 'Material') {
              seoAttributes[item.attributeName] = item.attributeValue;
            } else {
              seoAttributes[item.attributeName] = [item.attributeValue];
            }
          }
        });
      }
      
      // Preserve current price range when changing sort
      const currentPriceToUse = userAdjustedPrice ? currentPriceRange : finalPriceRange;
      const finalPayload = { ...updatedFilters, ...seoAttributes };
      
      // Add price range to payload if user has adjusted it
      if (userAdjustedPrice && currentPriceRange) {
        finalPayload.price = {
          min_price: parseFloat(currentPriceRange[0]),
          max_price: parseFloat(currentPriceRange[1])
        };
      }
      
      // Ensure Sort By is included in the payload
      if (category === "Sort By" && value) {
        finalPayload["Sort By"] = value;
      }
      
      dispatch(updateSelectedFilters(category, category === "Sort By" ? value : updatedFilters[category], currentPriceToUse));
      
      callAPI(
        (params) => dispatch(product_list_item(params, offSet)),
        finalPayload
      );
      
      return updatedFilters;
    });

    productListLoading.current = false;
  }, [dispatch, allattriButeValue, finalPriceRange, currentPriceRange, userAdjustedPrice, offSet, callAPI]);



  const handleChange = (event) => {
    const selectedOption = event.target.value;
    setSelectedValue(selectedOption); // Update the selected value

    // Find the corresponding category and option
    const selectedCategory = filterList[6]; // Since you're slicing 6-7, it's always 6th item
    const option = filters[selectedCategory]?.find(
      (item) => item.name === selectedOption
    );

    // Trigger onChange only if valid option is selected (no loading state)
    if (option) {
      handleFilterChange(selectedCategory, selectedOption);
    }
  };

  const toggleCategory = (category) => {
    setExpandedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };
  // const [skuId,setskuId]=(null)
  const { userProfile_id } = useSelector((state) => state.authReducer);

  const {
    //wishlist

    wishListDataSuccess,
  } = useSelector((state) => state.myAccountReducer);
  
  useEffect(() => {
    dispatch(getPersionalData(userProfile_id));
  }, [userProfile_id]);
  config.logGeneral &&
    console.log(wishListDataSuccess, "wishListDataSuccess999");
  config.logGeneral && console.log("===>selectedFilterstest", selectedFilters);
  const descriptionShow = (description) => {
    const maxLength = isMobile || isTablet ? 15 : 30;
    return description.length > maxLength
      ? description.slice(0, maxLength - 1) + ".."
      : description;
  };


    useEffect(() => {
    if (Object.keys(productListResponseSuccess).length > 0) {
      config.logGeneral &&
        config.logGeneral &&
        console.log(
          "productListResponseSuccess1234",
          productListResponseSuccess
        );
      // meta title
      var metatitle_raw = (productListResponseSuccess?.meta_title || [])
        .filter((e) => e !== null)
        .join(""); //meta_title
      var metadescription_raw = productListResponseSuccess?.seo_text || "";
      var metaseourl_raw = productListResponseSuccess?.seo_url;
      var meta_keyword = (productListResponseSuccess?.meta_keyword || [])
        .filter((e) => e !== null)
        .join(" ");
      var metaseotext_raw = productListResponseSuccess?.seo_text;
      if (metadescription_raw) {
        setmetadescription(metadescription_raw);
      }
      if (meta_keyword) {
        setmetakeyword(meta_keyword);
      }
      if (metaseotext_raw) {
        setmetaseotext(metaseotext_raw);
      }
      if (metaseourl_raw) {
        setseourl(metaseourl_raw);
      }
      config.logGeneral && console.log(metatitle_raw, "metatitle_raw888");
      var filtersNew = filterList?.reduce((acc, filterType) => {
        acc[filterType] = productListResponseSuccess[filterType] || [];
        // Log filter options to see if seourl is present
        if (acc[filterType].length > 0) {
          config.logGeneral && console.log(`${filterType} filter options:`, acc[filterType]);
          // Check specifically for Anniversary in Occasion
          if (filterType === 'Occasion') {
            const anniversaryOption = acc[filterType].find(option => option.name === 'Anniversary');
            config.logGeneral && console.log('Anniversary option:', anniversaryOption);
          }
        }
        return acc;
      }, {});
      config.logGeneral &&
        config.logGeneral &&
        console.log(getSeoData, filters.length, "======>filtersyy");
      // if (filters.length > 0) {
      //   productListLoading.current = false;
      // }
      const finalFilters = {
        ...filtersNew,
        "Sort By": [
          { name: "New to Stylori" },
          // { name: "Featured" },
          { name: "Price Low to High" },
          { name: "Price High to Low" },
          // { name: "Ready to Ship" },
          { name: "Best Seller" },
        ],
      };
      config.logGeneral && console.log('Setting filters with SEO URLs:', finalFilters);
      setfilters(finalFilters);
      var titlte = productListResponseSuccess?.title_h1?.filter(
        (e) => e !== null
      );
      var title_display = titlte.join(" ");
      settitle(title_display);

      if (getSeoData !== null) {
        const category = getSeoData?.map((item) => {
          return findCategoryByValue(item, filtersNew, allattriButeValue);
        });

        setCategory(
          category
            ?.flat()
            .filter(
              (item, index, self) =>
                index ===
                self.findIndex(
                  (t) =>
                    t.attributeName === item.attributeName &&
                    t.attributeValue === item.attributeValue
                )
            )
        );
      }
    }
  }, [productListResponseSuccess]);

  config.logGeneral &&
    config.logGeneral &&
    console.log(
      "==>selectedcountrySuccess123",
      productMaxPrice,
      "productMinPrice",
      productMinPrice
    );

  // const productsToDisplay =
  //   productListitemsResponseSuccess?.data?.allProductLists || [];
  config.logGeneral &&
    config.logGeneral &&
    console.log(
      "==>productListitemsResponseSuccess123",
      productListitemsResponseSuccess
    );

  useEffect(() => {
    if (productListitemsResponseSuccess?.data?.totalCount) {
      setAPITotalCount(productListitemsResponseSuccess?.data?.totalCount);
    }
    if (productListitemsResponseSuccess?.data?.allProductLists) {
      setProductsToDisplay(
        productListitemsResponseSuccess.data.allProductLists
      );
    }
  }, [productListitemsResponseSuccess]);
  config.logGeneral &&
    console.log(
      productListitemsResponseSuccess?.data?.allProductLists,
      "productListitemsResponseSuccess.data.allProductListskkk"
    );

  useEffect(() => {
    dispatch(productListIsLikedChange());
  }, [productListitemsResponesLoading]);
  useEffect(() => {
    dispatch(productListIsLikedChange());
  }, []);
  

  const handleAddToWishlist = (productSku, productId, isLiked) => {    
    if (!userProfile_id) {
      const existingWishlist =
          JSON.parse(localStorage.getItem("wishlistInLocalStorage")) || [];

        // Check if item already exists (optional, if you don't want duplicates)
        const isAlreadyAdded = existingWishlist.some(
          (item) =>
            item.productId === productId && item.productSku === productSku
        );
        if (!isAlreadyAdded) {
          existingWishlist.push({
            page: "productlist",
            productId,
            productSku,
          });

          localStorage.setItem(
            "wishlistInLocalStorage",
            JSON.stringify(existingWishlist)
          );
        }
      dispatch(addwishlistwithoutlogin(productSku, productId));
      dispatch(getAuthModalType(constants.Login));
      return;
    }

    if (isLiked) {
      //remove from wishlsit
      dispatch(
        removewishlistfromstore(
          userProfile_id,
          productId,
          productSku,
          wishListDataSuccess
        )
      );
      Toast("Product removed from wishlist successfully", "success");
      // dispatch(getPersionalData(userProfile_id));
    } else {
      // Call API to add the product to the wishlist
      dispatch(addWishlistWithLogin(userProfile_id, productSku, productId));
      Toast("Product Added to wishlist successfully", "success");
    }
    dispatch(productListIsLikedChanged(productSku, productId, isLiked)).then(
      () => {
        dispatch(getPersionalData(userProfile_id));
      }
    );
  };

  // Scroll to Top
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    const scrollPosition = scrollTop + windowHeight;

    // Show image if user is in the middle or bottom of page
    if (scrollPosition > documentHeight / 2) {
      setShowImage(true);
    } else {
      setShowImage(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  //SEO Data for Filter - Initialize API sequence
  useEffect(() => {
    // Reset API sequence state
    setApiStep(0);
    priceApiCallMade.current = false;
    prevSeoNodesRef.current = null;
    
    let pathnameSplit = window?.location?.pathname?.split(
      constants.ADDITIONAL_PATH + "/"
    );
    const splitHiphen = () => {
      if (pathnameSplit[1]?.indexOf("-")) {
        return pathnameSplit[1].split("-");
      }
    };
    const condition = { seofilter: { seoUrl: { in: splitHiphen() } } };
    config.logGeneral && console.log("Step 0: Calling SEO GraphQL API FIRST with:", condition);

    dispatch(intProductListItem());
    dispatch(fetchSEOData(condition));

    // Reset states when URL changes
    setCategory([]);
    setUserAdjustedPrice(false);
    hasRunOnce.current = false;
    initialApiCalled.current = false; // Reset API call flag for new URL
    
    // Get URL price parameters
    const urlStartPrice = filterSortFromURl(window?.location?.search)?.startprice || "0";
    const urlEndPrice = filterSortFromURl(window?.location?.search)?.endprice || "0";
    
    // Always reset price range to default when navigating to new URLs
    dispatch(updateCurrentPriceRange([0, 200000]));
    setFinalPriceRange(["0", "200000"]);
    // Clear any price filter from Redux state
    dispatch(resetSelectedFilters());
    
    setSelectedFilters({
      Collection: [],
      Theme: [],
      Occasion: [],
      Style: [],
      Finish: [],
      "Product Type": [],
      "Sort By": null,
    });
  }, [window.location.href]);

  // Control flag to prevent duplicate API calls
  const priceApiCallMade = useRef(false);
  
  // Disabled auto-trigger to prevent conflicts with sequential API flow
  // Price changes will be handled through the main sequential flow
  // min_price: formatCurrencywithamount(
  //   finalPriceRange[0],
  //   (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
  //   (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
  //   dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
  // ),
  // max_price: formatCurrencywithamount(
  //   finalPriceRange[1],
  //   (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : ''),
  //   (selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : ''),
  //   dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
  // ),
  // Validate and set price from URL with strict validation
  useEffect(() => {
    if (selectedcountrySuccess) {
      const urlParams = new URLSearchParams(window.location.search);
      const startPriceStr = urlParams.get('startprice');
      const endPriceStr = urlParams.get('endprice');
      
      // Convert to numbers for validation
      const startPriceNum = parseFloat(startPriceStr);
      const endPriceNum = parseFloat(endPriceStr);
      
      let validStartPrice = 0;
      let validEndPrice = 200000;
      let shouldUpdateURL = false;
      
      // Strict validation conditions
      if (isNaN(startPriceNum) || isNaN(endPriceNum)) {
        // If either value is non-numeric, set both to 0
        shouldUpdateURL = true;
      } else if (startPriceNum > endPriceNum) {
        // If startprice > endprice, consider both invalid
        shouldUpdateURL = true;
      } else if (startPriceNum >= 0 && endPriceNum >= 0 && startPriceNum <= endPriceNum) {
        // Both are valid and startprice <= endprice
        if (startPriceNum > 0 || endPriceNum > 0) {
          // If either value is greater than 0, use these values
          validStartPrice = startPriceNum;
          validEndPrice = endPriceNum;
          setUserAdjustedPrice(true);
        }
        // If both are 0, use default range (0-200000)
      } else {
        // Any other invalid case
        shouldUpdateURL = true;
      }
      
      // Update URL if validation failed
      if (shouldUpdateURL) {
        const newUrl = new URL(window.location);
        newUrl.searchParams.set('startprice', '0');
        newUrl.searchParams.set('endprice', '0');
        const urlString = newUrl.toString();
        window.history.replaceState({}, '', urlString);
        validStartPrice = 0;
        validEndPrice = 200000;
      }
      
      // Apply currency conversion if needed
      const priceValues = changePriceValue(
        validStartPrice.toString(), 
        validEndPrice.toString(),
        (selectedcountrySuccess?.currencyAlias || "") == constants.INR,
        selectedcountrySuccess?.fxConversionRate || 1
      );
      
      // Set the validated price range to slider
      dispatch(updateCurrentPriceRange([priceValues.startprice, priceValues.endprice]));
      setFinalPriceRange([`${priceValues.startprice}`, `${priceValues.endprice}`]);
      
      // Reset user adjusted flag when URL changes (unless we have valid price params)
      if (!shouldUpdateURL && (startPriceNum > 0 || endPriceNum > 0)) {
        setUserAdjustedPrice(true);
      } else {
        setUserAdjustedPrice(false);
      }
    }
  }, [selectedcountrySuccess, window.location.href]);

  config.logGeneral &&
    config.logGeneral &&
    console.log("productListLoadingtest", productListLoading.current);

  config.logGeneral &&
    config.logGeneral &&
    console.log(
      "======>initProductListtest",
      productListitemsResponesLoading,
      productListitemsResponseSuccess,
      productListLoading.current,
      allattriButeValue,
      !isMobileFilter
    );
  // Remove this useEffect to prevent duplicate API calls
  // The selectedFiltersNew useEffect handles API calls now
  config.logGeneral &&
    config.logGeneral &&
    console.log(
      "allattriButeValuelistchecking",
      selectedFilters,
      "productListLoading.current ",
      productListLoading.current,
      "selectedFilters",
      selectedFilters,
      offSet
    );

  config.logGeneral &&
    config.logGeneral &&
    console.log(
      "productListitemsResponesLoading",
      productListitemsResponesLoading,
      "productListResponesLoading",
      productListResponesLoading,
      "filters",
      filters,
      "selectedFilters",
      selectedFilters,
      "allattriButeValue",
      allattriButeValue,
      "productListitemsResponseSuccess",
      productListitemsResponseSuccess
    );

  // const sorbyChange = (category, mobile = null) => {
  //   setSelectedFilters((prev) => ({
  //     ...prev,
  //     [category]: null,
  //   }));
  //   if (category == "Sort By") {
  //     setSelectedValue("Sort By");
  //   }

  //   if (mobile == null) {
  //     productListLoading.current = false;
  //   }
  // };
  const sorbyChange = (category, itemToRemove = null) => {
    // Reset pagination when removing filters
    dispatch(resetPagination());
    SetOffset(0);
    setItemOffset(0);
    
    setSelectedFilters((prev) => {
      const current = prev[category];
      config.logGeneral && console.log("Before:", prev, current.length);

      let updated;
      if (Array.isArray(current)) {
        const updatedArray = current.filter((item) => item !== itemToRemove);
        updated = {
          ...prev,
          [category]: updatedArray.length > 0 ? updatedArray : [],
        };
      } else {
        updated = {
          ...prev,
          [category]: null,
        };
      }

      // Update URL with remaining filters (only for non-Sort By filters)
      if (category !== "Sort By") {
        updateUrlWithFilters(updated);
      }

      // Check if all filters are now empty (excluding Sort By)
      const hasAnyFilters = Object.entries(updated).some(([key, value]) => {
        if (key === "Sort By") return false;
        return Array.isArray(value) ? value.length > 0 : value !== null;
      });

      // If no filters remain and user hasn't adjusted price, redirect to default page
      if (!hasAnyFilters && !userAdjustedPrice) {
        navigate(constants.ADDITIONAL_PATH + constants.CLEAR_FILTER_REDIRECT_PATH);
        return updated;
      }

      productListLoading.current = true;
      config.logGeneral && console.log("After:", updated);
      

      
      // Update Redux state and make API call
      dispatch(updateSelectedFilters(category, updated[category], finalPriceRange));
      dispatch(product_list_item(cleanApiPayload(updated), 0)); // Use 0 offset for reset pagination
      return updated;
    });

    // Reset sort option if necessary
    if (category === "Sort By") {
      setSelectedValue("Sort By");
    }

    // Control loading flag
    if (itemToRemove === null) {
      productListLoading.current = false;
    }
  };

  // filterSortFromURl(window?.location?.search)
  function initProductList(clear = null) {
    // if(allattriButeValue.length > 0){
    //   //dispatch(product_listing_loading());
    config.logGeneral && console.log("===>initinside");
    config.logGeneral && console.log(selectedFiltersNew,"selectedFiltersNewzzzz")

    const hasChanged = !isEqual(prevValuesFilter.current, selectedFilters);
    config.logGeneral && console.log("===>initProductListclear", hasChanged);
    if (clear !== null) {
      setSelectedFilters({
        Collection: [],
        Theme: [],
        Occasion: [],
        Style: [],
        Finish: [],
        "Product Type": [],
        "Sort By": null,
      });
      //sorbyChange("Sort By");
      //window.location.replace(constants.ADDITIONAL_PATH+constants.CLEAR_FILTER_REDIRECT_PATH);
    }

    if (!isEmptyArray(productListResponseSuccess)) {

      // Filter and create a cleaned object
      // const cleanedFilters = Object.fromEntries(
      //   Object.entries(selectedFilters).filter(([key, value]) => {
      //     // Keep non-attribute fields like Sort By or price
      //     if (key === "Sort By" || key === "price") return true;

      //     // Check if the key exists in attribute list
      //     const exists = allattriButeValue.some(
      //       (attr) => attr.attributeName === key
      //     );
      //     return exists;
      //   })
      // );      
      // //check the redux value console cleanedfilters
      // dispatch(product_list_item(cleanedFilters, offSet));
      if (isMobileFilter) {
        closeModal();
      }
    }
  }

  const handleOnchange = (filterCategory, option) => {
    handleFilterChange(filterCategory, option.name);
    toggleCategory(filterCategory);
  };

  useEffect(() => {
    const currentSeoNodes =
      getSEODataResponseSuccess?.data?.allSeoUrlPriorities?.nodes;
    if (!currentSeoNodes || currentSeoNodes.length === 0) return;

    const hasChanged = !isEqual(prevSeoDataRef.current, currentSeoNodes);
    if (hasChanged) {
      setCategory([]);
      prevSeoDataRef.current = currentSeoNodes;
      
      setSeoData(
        getSEODataResponseSuccess?.data?.allSeoUrlPriorities?.nodes?.map(
          (item) => item.attributeValue
        )
      );
      
      config.logGeneral && console.log('Setting allattriButeValue:', currentSeoNodes);
      setAllattriButeValue(currentSeoNodes);
    }
  }, [getSEODataResponseSuccess]);
  // setPriceRange([
  //   filterSortFromURl(window?.location?.search)?.startprice ?? 0,
  //   (filterSortFromURl(window?.location?.search)?.endprice ?? 0) == 0 ||
  //   filterSortFromURl(window?.location?.search)?.endprice >
  //     changePriceValue(
  //       (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : '') == constants.INR
  //     )
  //     ? (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : '') == constants.INR
  //       ? 200000
  //       : 5000
  //     : (selectedcountrySuccess?.currencyAlias ? selectedcountrySuccess?.currencyAlias : '') == constants.INR
  //     ? filterSortFromURl(window?.location?.search)?.endprice
  //     : selectedcountrySuccess?.fxConversionRate *
  //       filterSortFromURl(window?.location?.search)?.endprice,
  // ]);

  useEffect(() => {
    if (!hasRunOnce.current && !isEmptyArray(Category)) {
      dispatch(resetSelectedFilters());
      hasRunOnce.current = true;
      
      const urlParams = filterSortFromURl(window?.location?.search);
      
      Category?.push({
        attributeName: "Sort By",
        attributeValue: urlParams?.sort,
      });
      setSelectedValue(urlParams?.sort);
      
      // Set price range from URL parameters
      const urlStartPrice = urlParams?.startprice || "0";
      const urlEndPrice = urlParams?.endprice || "0";
      const hasUrlPriceFilter = urlStartPrice !== "0" || urlEndPrice !== "0";
      
      let priceValues;
      if (urlStartPrice === "0" && urlEndPrice === "0") {
        priceValues = { startprice: 0, endprice: 200000 };
      } else {
        priceValues = changePriceValue(
          urlStartPrice,
          urlEndPrice,
          (selectedcountrySuccess?.currencyAlias || "") == constants.INR,
          selectedcountrySuccess?.fxConversionRate || 1
        );
      }
      
      if (!userAdjustedPrice) {
        dispatch(updateCurrentPriceRange([priceValues.startprice, priceValues.endprice]));
        setFinalPriceRange([`${priceValues.startprice}`, `${priceValues.endprice}`]);
      }
      
      // Build filters object from Category data - but don't trigger handleFilterChange
      const categoryFilters = {};
      Category?.forEach((item) => {
        if (item.attributeName && item.attributeValue) {
          if (item.attributeName === "Sort By") {
            categoryFilters[item.attributeName] = item.attributeValue;
          } else {
            if (!categoryFilters[item.attributeName]) {
              categoryFilters[item.attributeName] = [];
            }
            categoryFilters[item.attributeName].push(item.attributeValue);
          }
          if (item.attributeName !== "Sort By") {
            toggleCategory(item.attributeName);
          }
        }
      });
      
      // Reset and set only current URL-based filters
      const newFilters = {
        Collection: [],
        Theme: [],
        Occasion: [],
        Style: [],
        Finish: [],
        "Product Type": [],
        "Sort By": null,
        ...categoryFilters
      };
      
      // Add GraphQL SEO attributes to selectedFilters for display (exclude generic terms)
      if (allattriButeValue) {
        const excludeTerms = ['silver', 'jewellery', 'jewelry'];
        allattriButeValue.forEach((item) => {
          if (item.attributeName && item.attributeValue && item.attributeName !== "Sort By") {
            // Skip generic terms like 'silver' and 'jewellery'
            if (!excludeTerms.includes(item.attributeValue.toLowerCase())) {
              if (!newFilters[item.attributeName]) {
                newFilters[item.attributeName] = [];
              }
              if (!newFilters[item.attributeName].includes(item.attributeValue)) {
                newFilters[item.attributeName].push(item.attributeValue);
              }
            }
          }
        });
      }
      
      setSelectedFilters(newFilters);
      
      // Apply all filters at once to Redux - ensure proper sequencing
      if (Object.keys(categoryFilters).length > 0) {
        const priceToPass = hasUrlPriceFilter ? [priceValues.startprice, priceValues.endprice] : null;
        // Ensure GraphQL data is properly connected to Redux filters
        config.logGeneral && console.log(categoryFilters, "categoryFilters from GraphQL");
        config.logGeneral && console.log(allattriButeValue, "allattriButeValue from GraphQL");
        Object.entries(categoryFilters).forEach(([key, value]) => {
          dispatch(updateSelectedFilters(key, value, priceToPass));
        });
      }

      productListLoading.current = false;
    } else if (
      !hasRunOnce.current &&
      isEmptyArray(Category) &&
      filterSortByArrayBasedOnUrl().includes(
        filterSortFromURl(window?.location?.search)?.sort?.toLowerCase()
      )
    ) {
      hasRunOnce.current = true;
      productListLoading.current = false;

      const urlParams = filterSortFromURl(window?.location?.search);
      
      const urlStartPrice = urlParams?.startprice || "0";
      const urlEndPrice = urlParams?.endprice || "0";
      const hasUrlPriceFilter = urlStartPrice !== "0" || urlEndPrice !== "0";
      
      let priceValues;
      if (urlStartPrice === "0" && urlEndPrice === "0") {
        priceValues = { startprice: 0, endprice: 200000 };
      } else {
        priceValues = changePriceValue(
          urlStartPrice,
          urlEndPrice,
          (selectedcountrySuccess?.currencyAlias || "") == constants.INR,
          selectedcountrySuccess?.fxConversionRate || 1
        );
      }
      
      if (!userAdjustedPrice) {
        dispatch(updateCurrentPriceRange([priceValues.startprice, priceValues.endprice]));
        setFinalPriceRange([`${priceValues.startprice}`, `${priceValues.endprice}`]);
      }

      // Update state and Redux with GraphQL data connection
      setSelectedFilters(prev => ({ ...prev, "Sort By": urlParams?.sort }));
      const priceToPass = hasUrlPriceFilter ? [priceValues.startprice, priceValues.endprice] : null;
      dispatch(updateSelectedFilters("Sort By", urlParams?.sort, priceToPass));
      setCategory([
        { attributeName: "Sort By", attributeValue: urlParams?.sort },
      ]);
      config.logGeneral && console.log("Sort By filter set with GraphQL connection");
    }
  }, [Category]);
  

  useEffect(() => {
    hasRunOnce.current = false;
    productListLoading.current = false;
    // Reset user adjusted price when SEO data changes (new URL)
    setUserAdjustedPrice(false);
  }, [getSeoData]);



  // Modal
  const customStyles = {
    content: {
      top: "18%",
      left: "5%",
      right: "5%",
      bottom: "auto",
      transform: "translate(0%, 0%)",
      overflow: "auto",
    },
  };

  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
    setIsMobileFilter(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsOpen(false);
    setIsMobileFilter(false);
  }
  const handlePageClick = useCallback((event) => {
    const newOffset = event.selected * limit;
    const pageNumber = event.selected + 1; // Convert 0-based to 1-based
    productListLoading.current = false;
    
    dispatch(setPaginationOffset(newOffset, event.selected));
    setItemOffset(event.selected);
    SetOffset(newOffset);
    
    // Update URL with page parameter while preserving original sort encoding
    const currentUrl = new URL(window.location.href);
    const originalSortParam = currentUrl.searchParams.get('sort');
    
    if (pageNumber > 1) {
      currentUrl.searchParams.set('page', pageNumber.toString());
    } else {
      currentUrl.searchParams.delete('page');
    }
    
    // Preserve original sort parameter encoding (%20 instead of +)
    if (originalSortParam) {
      const urlString = currentUrl.toString();
      const finalUrl = urlString.replace(/sort=[^&]+/, `sort=${encodeURIComponent(originalSortParam)}`);
      window.history.replaceState({}, '', finalUrl);
    } else {
      window.history.replaceState({}, '', currentUrl.toString());
    }
    
    // Build payload with current filters and URL price parameters
    const paginationPayload = { ...cleanApiPayload(selectedFiltersNew) };
    
    // Add SEO attributes
    if (allattriButeValue) {
      allattriButeValue.forEach((item) => {
        if (item.attributeName && item.attributeValue) {
          const attrName = item.attributeName;
          switch (attrName) {
            case 'Product Type':
              paginationPayload.producttype = item.attributeValue;
              break;
            case 'Material':
              paginationPayload.material = item.attributeValue;
              break;
            case 'Category':
              paginationPayload.category = item.attributeValue;
              break;
            default:
              paginationPayload[attrName.toLowerCase().replace(/\s+/g, '')] = item.attributeValue;
          }
        }
      });
    }
    
    // Add URL price parameters
    const startPrice = parseInt(params.get('startprice') || '0');
    const endPrice = parseInt(params.get('endprice') || '0');
    if (!(startPrice === 0 && endPrice === 0)) {
      paginationPayload.price = {
        min_price: startPrice,
        max_price: endPrice
      };
    }
    
    // Add sort parameter from URL
    const urlSortParam = params.get('sort');
    if (urlSortParam) {
      paginationPayload['Sort By'] = decodeURIComponent(urlSortParam);
    }
    
    dispatch(product_list_item(paginationPayload, newOffset));
    
    window.scrollTo(0, 0);
  }, [dispatch, selectedFiltersNew, allattriButeValue, params]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowImage(true);
      } else {
        setShowImage(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>{metatitle}</title>
        <meta property="og:title" id="fb-title" content={metatitle} />
        <meta name="description" content={metadescription} />
        <meta name="keywords" content={metakeyword} />
        <meta property="og:site_name" content="Stylori" />
        <meta property="og:description" content={metadescription} />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          id="fb-product-url"
          content={window.location.href}
        />
        <meta
          property="og:image"
          id="fb_imageUrl"
          content={
            productsToDisplay[0]?.productImagesByProductId[0]?.imageUrl ||
            constants.DEFAULT_IMAGE
          }
        />
        <meta property="og:image:width" content="200" />
        <meta property="og:image:height" content="200" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@StyloriLove" />{" "}
        <meta name="twitter:creator" content="@StyloriSilver"></meta>
        <meta name="twitter:title" id="twitter-title" content={seourl} />
        <meta name="twitter:description" content={metaseotext} />
        <meta
          name="twitter:image"
          content={
            productsToDisplay[0]?.productImagesByProductId[0]?.imageUrl ||
            constants.DEFAULT_IMAGE
          }
        ></meta>
        <meta name="robots" content="index, follow" />
        <meta property="og:locale" content="en_US" />
      </Helmet>
      <body className="bg-white-100">
        <div className="container mx-auto p-4">
          <div className="flex justify-center items-center mb-5">
            <h1 className="font-tiemann font-medium lg:text-[40px] text-[24px] text-[#1a1a1a] text-center">
              {title}
            </h1>
          </div>
          
          <div className="lg:flex items-center relative gap-4 justify-between mb-5">
            <div className="relative invisible hidden lg:block">
              <select
                value={selectedValue}
                onChange={handleChange}
                className="appearance-none w-full px-4 py-2 border border-customGreen shadow-sm focus:outline-none focus:ring-2 focus:ring-customGreen focus:border-customGreen pr-10 bg-white"
              >
                <option disabled className=" text-black">
                  Sort By
                </option>
                {filterList?.slice(6, 7)?.map((filterCategory) =>
                  filters[filterCategory]?.map((option, idx) => (
                    <option key={idx} value={option.name}>
                      {option.name}
                    </option>
                  ))
                )}
              </select>
              <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                <img
                  src={
                    constants.DEFAULT_IMAGE + "/product_care_accortian_down.png"
                  }
                  className="w-4"
                />
              </div>
            </div>
            {metadescription && (
            <div className="flex justify-center items-center mb-5">
              <p className="text-center text-gray-700 max-w-4xl text-lg">
                {isDescriptionExpanded || metadescription.length <= 150 
                  ? metadescription 
                  : `${metadescription.substring(0, 150)}...`}
                {metadescription.length > 150 && (
                  <button 
                    onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
                    className="text-customGreen font-medium ml-2 hover:underline"
                  >
                    {isDescriptionExpanded ? 'Show Less' : 'Show More'}
                  </button>
                )}
              </p>
            </div>
          )}
            <div className="relative hidden lg:block">
              <select
                value={selectedValue}
                onChange={handleChange}
                className="appearance-none w-full px-4 py-2 border border-customGreen shadow-sm focus:outline-none focus:ring-2 focus:ring-customGreen focus:border-customGreen pr-10 bg-white"
              >
                <option disabled className=" text-black">
                  Sort By
                </option>
                {filterList?.slice(6, 7)?.map((filterCategory) =>
                  filters[filterCategory]?.map((option, idx) => (
                    <option key={idx} value={option.name}>
                      {option.name}
                    </option>
                  ))
                )}
              </select>
              <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                <img
                  src={
                    constants.DEFAULT_IMAGE + "/product_care_accortian_down.png"
                  }
                  className="w-4"
                />
              </div>
            </div>
          </div>
          
          <Link to={constants.ADDITIONAL_PATH + "/contactus"}>
            <button className="flex bg-white fixed top-1/2 transform rotate-[270deg] lg:-left-14 -left-12 rounded-bl-2xl rounded-br-2xl lg:py-2 lg:px-4 py-2 px-3 text-[#020307] font-tiemann font-medium tracking-wider lg:text-xl text-base shadow-md z-[2]">
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="transform rotate-[90deg] pt-1"
              >
                <path
                  d="M14.8063 1.4124C14.0725 1.88413 13.3649 2.35585 12.6311 2.82758C12.4739 2.9324 12.3691 2.9324 12.2118 2.82758C11.5042 2.35585 10.7967 1.91034 10.0891 1.43861C9.25045 0.888265 8.43803 1.17654 8.09734 2.11999C7.80906 2.9062 7.49458 3.6924 7.20631 4.47861C7.15389 4.63585 7.04906 4.71447 6.86562 4.71447C6.00079 4.74068 5.13596 4.79309 4.29734 4.84551C3.3801 4.89792 2.85596 5.6055 3.09182 6.49654C3.30148 7.33516 3.53734 8.17378 3.7732 8.98619C3.82562 9.16964 3.7732 9.27447 3.64217 9.40551C2.96079 9.92964 2.30561 10.48 1.65044 11.0041C0.916649 11.5807 0.916649 12.4717 1.65044 13.0745C2.30561 13.5986 2.96079 14.149 3.61596 14.6469C3.79941 14.7779 3.82562 14.909 3.7732 15.1186C3.53734 15.931 3.32769 16.7434 3.17044 17.32C2.90837 18.4469 3.35389 19.1283 4.29734 19.1807C5.16217 19.2331 6.027 19.2855 6.91803 19.3117C7.10148 19.3117 7.1801 19.3903 7.25872 19.5476C7.5732 20.36 7.88768 21.1724 8.20217 21.9848C8.54286 22.8234 9.35527 23.0855 10.1153 22.5876C10.8491 22.1158 11.5567 21.6441 12.2904 21.1724C12.4477 21.0676 12.5525 21.0676 12.736 21.1724C13.4698 21.6703 14.2036 22.1421 14.9635 22.6138C15.6711 23.0593 16.5098 22.771 16.8242 21.9848C17.1387 21.1724 17.4532 20.3338 17.7677 19.5214C17.8201 19.3379 17.9249 19.2855 18.1084 19.2855C18.947 19.2593 19.7594 19.1545 20.598 19.1545C21.4367 19.1545 22.1967 18.4207 21.8822 17.3986C21.6201 16.5862 21.4366 15.7738 21.2008 14.9614C21.1484 14.8041 21.1746 14.6993 21.3318 14.5945C22.0132 14.0441 22.6684 13.52 23.3498 12.9697C24.0835 12.3669 24.0835 11.5021 23.3498 10.9255C22.6684 10.3752 22.0132 9.85103 21.3318 9.30069C21.2008 9.19586 21.1484 9.11724 21.2008 8.93379C21.4366 8.09517 21.6463 7.25655 21.8822 6.41793C22.118 5.5531 21.5939 4.81931 20.7029 4.7931C19.838 4.74069 18.9732 4.68828 18.0822 4.66207C17.8725 4.66207 17.7939 4.55724 17.7415 4.4C17.4532 3.61379 17.1387 2.80138 16.8242 2.01517C16.4049 1.17654 15.5663 0.914472 14.8063 1.4124ZM10.5084 7.67585L15.7498 12.9172C15.8808 13.0483 15.9856 13.2317 16.0118 13.4152C16.0118 13.4676 16.038 13.5462 16.038 13.5986C16.038 13.8345 15.9332 14.0965 15.7498 14.28L13.6008 16.429C13.2339 16.7958 12.6311 16.7958 12.2642 16.429C11.8973 16.0621 11.8973 15.4593 12.2642 15.0924L13.7318 13.6248L9.17182 9.06481C8.80493 8.69792 8.80493 8.09516 9.17182 7.72826C9.53872 7.30895 10.1415 7.30895 10.5084 7.67585Z"
                  fill="#15AB9E"
                />
              </svg>
              Get Enquiry
            </button>
          </Link>
          {!isDataFullyLoaded && productListitemsResponesLoading ? (
            <div className="flex justify-center items-center min-h-[500px] w-full">
              <div className="text-center py-6 flex flex-col items-center">
                <img
                  src={constants.DEFAULT_IMAGE + "/loaderimagesilver.gif"}
                  alt="loading"
                  className="w-120 h-120"
                />
                <p className="text-lg text-gray-600 mt-4">Loading products and filters...</p>
              </div>
            </div>
          ) : (
          <div className="flex gap-6">
            <div
              className="hidden lg:block w-1/4 bg-white p-4 h-[900px] overflow-auto  [&::-webkit-scrollbar]:w-1
                        [&::-webkit-scrollbar-track]:rounded-full
                        [&::-webkit-scrollbar-track]:bg-gray-100
                        [&::-webkit-scrollbar-thumb]:rounded-full
                        [&::-webkit-scrollbar-thumb]:bg-[#D0D0D0]
                        dark:[&::-webkit-scrollbar-track]:bg-neutral-700
                        dark:[&::-webkit-scrollbar-thumb]:bg-[#D0D0D0]
                         sticky top-28"
            >
              {/* Applied Filters */}
              <div className="flex justify-between items-center mb-4">
                <h2 className=" text-[#242424]  tracking-wide text-lg font-semibold leading-normal uppercase">
                  Applied Filters
                </h2>
                {Object.entries(selectedFilters).some(
                  ([key, value]) => key !== "price" && (Array.isArray(value) ? value.length > 0 : value !== null)
                ) && (
                  <button
                    className="text-customGreen text-xs font-bold leading-normal underline decoration-solid [text-decoration-skip-ink:none] decoration-auto underline-offset-auto [text-underline-position:from-font] uppercase"
                    onClick={() => {
                      // Navigate to default silver jewellery page
                      navigate(constants.ADDITIONAL_PATH + constants.CLEAR_FILTER_REDIRECT_PATH);
                    }}
                  >
                    Clear Filter
                  </button>
                )}
              </div>

              {/* Display Filters (Exclude Price) */}
              {/* <div className="flex flex-wrap gap-2 mb-4">
                {Object?.entries(selectedFilters)?.map(
                  ([category, selectedItem]) =>
                    category !== "price" &&
                    selectedItem && (
                      <span
                        key={category}
                        className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424]  text-base font-medium rounded-full "
                      >
                        {selectedItem}
                        <button
                          className="ml-2 text-black hover:text-gray-900 text-xs font-semibold"
                          onClick={() => {
                            sorbyChange(category);
                            SetOffset(0);
                            setItemOffset(0);
                          }}
                        >
                          ✕
                        </button>
                      </span>
                    )
                )}
              </div> */}
              <div className="flex flex-wrap gap-2 mb-4 px-0">
                {Object.entries(selectedFilters).map(
                  ([category, selectedItem]) => {
                    if (
                      category === "undefined" ||
                      category === "price" ||
                      !selectedItem
                    )
                      return null;

                    // Handle array-type filters
                    if (Array.isArray(selectedItem)) {
                      return selectedItem.filter(item => item && item !== "").map(
                        (item) => (
                            <span
                              key={`${category}-${item}`}
                              className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424] text-base font-medium rounded-full"
                            >
                              {item}
                              <button
                                className="ml-2 text-gray-600 hover:text-gray-900"
                                onClick={() => sorbyChange(category, item)}
                              >
                                ✕
                              </button>
                            </span>
                          )
                      );
                    }

                    // Handle string-type filters
                    if (!selectedItem || selectedItem === "") return null;
                    
                    return (
                      <span
                        key={category}
                        className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424] text-base font-medium rounded-full"
                      >
                        {selectedItem}
                        <button
                          className="ml-2 text-gray-600 hover:text-gray-900"
                          onClick={() => sorbyChange(category, selectedItem)}
                        >
                          ✕
                        </button>
                      </span>
                    );
                  }
                )}
              </div>

              <div className="border border-b-customGreen border-l-0 border-r-0 border-t-0 opacity-[0.25]"></div>

              <div className="w-full mt-4">
                {/* Pricing Range Header */}
                <h2 className=" mb-2 text-[#242424]  tracking-wider text-lg font-semibold leading-normal uppercase">
                  Pricing Range
                </h2>
                <div className="flex justify-between mb-2">
                  <span className="text-[#242424] font-medium text-base">
                    {formatCurrencywithamount(
                      currentPriceRange?.[0] || productMinPrice || 0,
                      selectedcountrySuccess?.currencyAlias
                        ? selectedcountrySuccess?.currencyAlias
                        : "",
                      selectedcountrySuccess?.iso
                        ? `en-${selectedcountrySuccess?.iso}`
                        : "",
                      dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                    )}
                  </span>
                  <span className="text-[#242424] font-medium text-base">
                    {formatCurrencywithamount(
                      currentPriceRange?.[1] || productMaxPrice || 200000,
                      selectedcountrySuccess?.currencyAlias
                        ? selectedcountrySuccess?.currencyAlias
                        : "",
                      selectedcountrySuccess?.iso
                        ? `en-${selectedcountrySuccess?.iso}`
                        : "",
                      dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                    )}
                  </span>
                </div>


                {/* React-Range Slider */}
                <Range
                  key={`0-200000`}
                  step={200}
                  min={0}
                  max={200000}
                  values={currentPriceRange || [productMinPrice || 0, productMaxPrice || 200000]}
                  onChange={handlePriceChange}
                  onFinalChange={handleFinalPriceChange}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      className="w-full h-2 bg-[#EEEEEE] rounded relative z-[1]"
                    >
                      <div
                        className="absolute h-2 bg-teal-500 rounded"
                        style={{
                          left: `${
                            currentPriceRange ? (currentPriceRange[0] / 200000) * 100 : 0
                          }%`,
                          right: `${
                            currentPriceRange ? 100 - (currentPriceRange[1] / 200000) * 100 : 0
                          }%`,
                        }}
                      />
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      {...props}
                      className="w-5 h-5 bg-white border-[5px] border-customGreen rounded-full shadow cursor-pointer focus:outline-none"
                    />
                  )}
                />

              </div>

              <div className="border border-b-customGreen border-l-0 border-r-0 border-t-0 opacity-[0.25] mt-6 mb-3"></div>

              {/* Filter Categories */}
              <div className="">
                {filterList?.slice(0, 6)?.map((filterCategory) => (
                  <div key={filterCategory}>
                    {/* Collapsible Section Header */}

                    <div
                      className="flex justify-between items-center cursor-pointer py-2 text-lg font-semibold"
                      onClick={() => toggleCategory(filterCategory)}
                    >
                      <span className="text-[#242424] tracking-wider text-lg font-semibold leading-normal uppercase">
                        {filterCategory}
                      </span>
                      <span className="text-gray-500">
                        {expandedCategories.includes(filterCategory) ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5 15l7-7 7 7"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        )}
                      </span>
                    </div>

                    {/* Filter Options */}
                    {expandedCategories.includes(filterCategory) && (
                      <div className="space-y-2 mt-2">
                        {filters[filterCategory]?.map((option, idx) => (
                          <>
                            <label
                              key={idx}
                              className="flex items-center space-x-2"
                            >
                              <input
                                type="checkbox"
                                className={`w-5 h-5 rounded border border-gray-400 bg-white checked:bg-gradient-to-r from-customGreen to-[#00867A] checked:border-customGreen text-white appearance-none checked:after:content-['✓'] checked:after:text-white checked:after:flex checked:after:justify-center checked:after:items-center checked:after:w-full checked:after:h-full`}
                                onChange={() =>
                                  handleFilterChange(
                                    filterCategory,
                                    option.name
                                  )
                                }
                                // checked={
                                //   selectedFilters[filterCategory] ===
                                //   option.name || false
                                // }
                                checked={
                                  selectedFilters[filterCategory]?.includes(
                                    option.name
                                  ) || false
                                }
                              />
                              <span className="text-[#242424] text-base font-medium leading-relaxed">
                                {option.name}
                              </span>
                            </label>
                          </>
                        ))}
                      </div>
                    )}
                    <div className="border border-b-customGreen border-l-0 border-r-0 border-t-0 opacity-[0.25] mt-2 mb-2"></div>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:w-3/4 w-full flex flex-col items-center">
              {productsToDisplay?.length > 0 ? (
                <div className="lg:grid lg:grid-cols-3 lg:gap-6 grid grid-cols-2 gap-2 pb-10">
                  {productsToDisplay?.map((product) => {
                    var {
                      productName,
                      productId,
                      trans_sku_lists,
                      productImagesByProductId,
                      selling_qty,
                      is_featured,
                    } = product;
                    productImagesByProductId = productImagesByProductId?.sort((a, b) => a?.imagePosition - b?.imagePosition);
                    const productImage =
                      productImagesByProductId[0]?.imageUrl ||
                      constants.DEFAULT_NO_PRODUCT_IMAGE;                      
                      const productImage2 =
                      productImagesByProductId[1]?.imageUrl || productImagesByProductId[2]?.imageUrl || productImagesByProductId[0]?.imageUrl ||
                      constants.DEFAULT_NO_PRODUCT_IMAGE;
                    const productUrl = trans_sku_lists[0]?.skuUrl || "#";
                    const sellingPrice = trans_sku_lists[0]?.markupPrice;
                    const discount_price = trans_sku_lists[0]?.discountPrice;
                    const discount = trans_sku_lists[0]?.discount || null;

                    return (
                      <ProductCard
                        key={product.productId}
                        product={product}
                        wishListDataSuccess={wishListDataSuccess}
                        handleAddToWishlist={handleAddToWishlist}
                        selectedcountrySuccess={selectedcountrySuccess}
                        dailyMetalPriceSuccess={dailyMetalPriceSuccess}
                        constants={constants}
                        getImage={getImage}
                        formatCurrencywithamount={formatCurrencywithamount}
                        descriptionShow={descriptionShow}
                        setHoveredProductId={setHoveredProductId}
                      />
                    );
                  })}
                </div>
              ) : (
                <div className="text-center py-6 flex flex-col items-center">
                  <img
                    src={constants.DEFAULT_IMAGE + "/no-product.svg"}
                    alt="Sorry, No Product Found"
                    className="w-120 h-120"
                  />
                  <p className="text-xl font-semibold text-[#262626]">
                    Sorry, No Product Found
                  </p>
                </div>
              )}

              {/* pagination ==============================> */}

              <div className="w-auto flex justify-content-center">
                {productsToDisplay?.length !== 0 &&
                  !productListitemsResponesLoading &&
                  (apiTotalCount / limit > 1 ? (
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextLinkClassName="page-link"
                      nextClassName="page-item"
                      breakLabel="..."
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      pageCount={Math.ceil(apiTotalCount / limit)}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={handlePageClick}
                      containerClassName="pagination flex flex-wrap justify-center gap-2"
                      activeClassName="active"
                      forcePage={itemOffset}
                      disabledClassName="opacity-50 cursor-not-allowed"
                    />
                  ) : (
                    <p className="text-[24px] font-semibold underline decoration-[#06ab9f] text-black">
                      1
                    </p>
                  ))}
                {/* pagenation ==============================> */}
                {/* {productsToDisplay?.length !== 0 &&
                productListLoading.current &&
                (apiTotalCount / limit > 1 ? (
                  <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    nextClassName={`page-item ${
                      itemOffset + limit >= apiTotalCount ? "hidden" : ""
                    }`}
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={Math.ceil(apiTotalCount / limit)}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={handlePageClick}
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={itemOffset}
                  />
                ) : (
                  <p className="text-[24px]  font-semibold underline decoration-[#06ab9f] text-black">
                    1
                  </p>
                ))} */}
              </div>

              
              <div className="flex lg:flex-col items-end gap-4 justify-center mb-5 lg:hidden sticky bottom-0 mt-8 bg-white p-4 shadow-top-only z-[1]">
                <div className="space-y-4 border w-[150px] bg-white border-customGreen lg:hidden block">
                  <div
                    className="flex px-4 py-[10px] justify-start gap-3"
                    onClick={openModal}
                  >
                    <img src={constants.DEFAULT_IMAGE + "/filter.svg"} />
                    <p className="font-medium text-sm text-[#242424]">
                      Filters
                    </p>
                  </div>
                </div>

                <div className="relative">
                  <select
                    value={selectedValue}
                    onChange={handleChange}
                    className="appearance-none w-[150px] px-4 py-2 border border-customGreen shadow-sm focus:outline-none focus:ring-2 focus:ring-customGreen focus:border-customGreen pr-10 bg-white"
                  >
                    <option disabled className=" text-black">
                      Sort By
                    </option>
                    {filterList?.slice(6, 7)?.map((filterCategory) =>
                      filters[filterCategory]?.map((option, idx) => (
                        <option key={idx} value={option.name}>
                          {option.name}
                        </option>
                      ))
                    )}
                  </select>
                  <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                    <img
                      src={
                        constants.DEFAULT_IMAGE +
                        "/product_care_accortian_down.png"
                      }
                      className="w-4"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Filters */}
            <Modal
              isOpen={modalIsOpen}
              onAfterOpen={afterOpenModal}
              onRequestClose={closeModal}
              style={customStyles}
              contentLabel="Example Modal"
            >
              <div className="flex justify-between items-center pb-5 bg-white pt-8 z-[1] px-4 sticky top-0">
                <div className="">
                  <h2 className=" text-[#242424]  text-lg font-semibold leading-normal uppercase">
                    Applied Filters
                  </h2>
                </div>
                <button onClick={closeModal} className="absolute right-3">
                  <img src={constants.DEFAULT_IMAGE + "/close.svg"} />
                </button>
              </div>

              {/* Display Filters (Exclude Price) */}
              <div className="bg-white sticky top-[79px] z-[1] w-full px-5">
                {/* <div className="flex flex-wrap gap-2 mb-4 px-4">
                  {Object?.entries(selectedFilters)?.map(
                    ([category, selectedItem]) =>
                      category !== "price" &&
                      selectedItem && (
                        <span
                          key={category}
                          className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424]  text-base font-medium rounded-full "
                        >
                          {selectedItem}
                          <button
                            className="ml-2 text-gray-600 hover:text-gray-900"
                            onClick={() => {
                              sorbyChange(category, "mobile");
                            }}
                          >
                            ✕
                          </button>
                        </span>
                      )
                  )}
                </div> */}


                <div className="flex flex-wrap gap-2 mb-4 px-4">
                  {Object.entries(selectedFilters).map(
                    ([category, selectedItem]) => {
                      if (
                        category === "undefined" ||
                        category === "price" ||
                        !selectedItem
                      )
                        return null;

                      // Handle array-type filters
                      if (Array.isArray(selectedItem)) {
                        return selectedItem.filter(item => item && item !== "").map(
                          (item) => (
                              <span
                                key={`${category}-${item}`}
                                className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424] text-base font-medium rounded-full"
                              >
                                {item}
                                <button
                                  className="ml-2 text-gray-600 hover:text-gray-900"
                                  onClick={() => sorbyChange(category, item)}
                                >
                                  ✕
                                </button>
                              </span>
                            )
                        );
                      }

                      // Handle string-type filters
                      if (!selectedItem || selectedItem === "") return null;
                      
                      return (
                        <span
                          key={category}
                          className="flex items-center px-3 py-1 bg-[#DCF2F0] text-[#242424] text-base font-medium rounded-full"
                        >
                          {selectedItem}
                          <button
                            className="ml-2 text-gray-600 hover:text-gray-900"
                            onClick={() => sorbyChange(category, selectedItem)}
                          >
                            ✕
                          </button>
                        </span>
                      );
                    }
                  )}
                </div>
                
                <div className="border border-b-customGreen border-l-0 border-r-0 border-t-0 opacity-[0.25]"></div>
                
                              <div className="w-full mt-4">
                                {/* Pricing Range Header */}
                                <h2 className=" mb-2 text-[#242424]  tracking-wider text-lg font-semibold leading-normal uppercase">
                                  Pricing Range
                                </h2>
                                <div className="flex justify-between mb-2">
                                  <span className="text-[#242424] font-medium text-base">
                                    {formatCurrencywithamount(
                                      currentPriceRange?.[0] || 0,
                                      selectedcountrySuccess?.currencyAlias
                                        ? selectedcountrySuccess?.currencyAlias
                                        : "",
                                      selectedcountrySuccess?.iso
                                        ? `en-${selectedcountrySuccess?.iso}`
                                        : "",
                                      dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                                    )}
                                  </span>
                                  <span className="text-[#242424] font-medium text-base">
                                    {formatCurrencywithamount(
                                      currentPriceRange?.[1] || 200000,
                                      selectedcountrySuccess?.currencyAlias
                                        ? selectedcountrySuccess?.currencyAlias
                                        : "",
                                      selectedcountrySuccess?.iso
                                        ? `en-${selectedcountrySuccess?.iso}`
                                        : "",
                                      dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
                                    )}
                                  </span>
                                </div>
                
                                {/* React-Range Slider */}
                                <Range
                                  key={`mobile-0-200000`}
                                  step={200}
                                  min={0}
                                  max={200000}
                                  values={currentPriceRange || [productMinPrice || 0, productMaxPrice || 200000]}
                                  onChange={handlePriceChange}
                                  onFinalChange={handleFinalPriceChange}
                                  renderTrack={({ props, children }) => (
                                    <div
                                      {...props}
                                      className="w-full h-2 bg-[#EEEEEE] rounded relative z-[1]"
                                    >
                                      <div
                                        className="absolute h-2 bg-teal-500 rounded"
                                        style={{
                                          left: `${
                                            currentPriceRange ? (currentPriceRange[0] / 200000) * 100 : 0
                                          }%`,
                                          right: `${
                                            currentPriceRange ? 100 - (currentPriceRange[1] / 200000) * 100 : 0
                                          }%`,
                                        }}
                                      />
                                      {children}
                                    </div>
                                  )}
                                  renderThumb={({ props }) => (
                                    <div
                                      {...props}
                                      className="w-5 h-5 bg-white border-[5px] border-customGreen rounded-full shadow cursor-pointer focus:outline-none"
                                    />
                                  )}
                                />
                
                              </div>
                
                              <div className="border border-b-customGreen border-l-0 border-r-0 border-t-0 opacity-[0.25] mt-6 mb-3"></div>

                

               
              </div>


              {/* Filter Categories */}
              <div className="">
                {filterList?.slice(0, 6)?.map((filterCategory) => (
                  <div key={filterCategory}>
                    {/* Collapsible Section Header */}

                    <div
                      className="flex justify-between items-center cursor-pointer py-2 text-lg font-semibold px-4"
                      onClick={() => toggleCategory(filterCategory)}
                    >
                      <span className="text-[#242424]  text-lg font-semibold leading-normal uppercase">
                        {filterCategory}
                      </span>
                      <span className="text-gray-500">
                        {expandedCategories.includes(filterCategory) ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5 15l7-7 7 7"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-5 h-5"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        )}
                      </span>
                    </div>

                    {/* Filter Options */}
                    {expandedCategories.includes(filterCategory) && (
                      <div className="space-y-2 mt-2 px-4">
                        {filters[filterCategory]?.map((option, idx) => (
                          <>
                            <label
                              key={idx}
                              className="flex items-center space-x-2"
                            >
                              <input
                                type="checkbox"
                                className={`w-5 h-5 rounded border border-gray-400 bg-white checked:bg-gradient-to-r from-customGreen to-[#00867A] checked:border-customGreen text-white appearance-none checked:after:content-['✓'] checked:after:text-white checked:after:flex checked:after:justify-center checked:after:items-center checked:after:w-full checked:after:h-full`}
                                onChange={() =>
                                  handleFilterChange(
                                    filterCategory,
                                    option.name
                                  )
                                }
                                // checked={
                                //   selectedFilters[filterCategory] ===
                                //   option.name || false
                                // }
                                checked={
                                  selectedFilters[filterCategory]?.includes(
                                    option.name
                                  ) || false
                                }
                              />
                              <span className="text-[#242424] text-base font-medium leading-relaxed">
                                {option.name}
                              </span>
                            </label>
                          </>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div className="flex gap-3 justify-between pt-4 pb-4 sticky bottom-0 bg-white px-4">
                <button
                  className="text-customGreen border border-customGreen text-xs font-bold leading-normal [text-decoration-skip-ink:none] decoration-auto underline-offset-auto [text-underline-position:from-font] uppercase px-8 py-2"
                  onClick={() => {
                    // Navigate to default silver jewellery page
                    navigate(constants.ADDITIONAL_PATH + constants.CLEAR_FILTER_REDIRECT_PATH);
                  }}
                >
                  Clear Filter
                </button>
                <button
                  className="text-white bg-customGreen border border-customGreen text-xs font-bold leading-normal [text-decoration-skip-ink:none] decoration-auto underline-offset-auto [text-underline-position:from-font] uppercase px-8 py-2"
                  onClick={() => {
                    if (
                      Object.keys(selectedFilters).length > 0 &&
                      isMobileFilter
                    ) {
                      dispatch(resetPagination());
                      initProductList();
                      productListLoading.current = true;
                    } else {
                      // alert("no filter");
                    }
                    SetOffset(0);
                    setItemOffset(0);
                  }}
                >
                  Show Results
                </button>
              </div>
            </Modal>
          </div>
          )}
          {/* {showImage && <div className="border fixed right-9 bottom-40 z-0 bg-white rounded-full w-10 h-10 hover:shadow-md">
          <img src={ constants.DEFAULT_IMAGE + "/top-arrow.svg" } className="w-10 h-10 p-3 transition-opacity duration-300" onClick={()=>window.scrollTo({ top: 0, behavior: 'smooth' })} />
        </div>} */}
        </div>
      </body>
    </>
  );
}

// Memoized ProductCard component for better performance
const ProductCard = React.memo(({ 
  product, 
  wishListDataSuccess, 
  handleAddToWishlist, 
  selectedcountrySuccess, 
  dailyMetalPriceSuccess, 
  constants, 
  getImage, 
  formatCurrencywithamount, 
  descriptionShow,
  setHoveredProductId 
}) => {
  const {
    productName,
    productId,
    trans_sku_lists,
    productImagesByProductId,
    selling_qty,
    is_featured,
  } = product;
  
  const productImage = productImagesByProductId[0]?.imageUrl || constants.DEFAULT_NO_PRODUCT_IMAGE;
  const productImage2 = productImagesByProductId[1]?.imageUrl || productImagesByProductId[0]?.imageUrl || constants.DEFAULT_NO_PRODUCT_IMAGE;
  const productUrl = trans_sku_lists[0]?.skuUrl || "#";
  const sellingPrice = trans_sku_lists[0]?.markupPrice;
  const discount_price = trans_sku_lists[0]?.discountPrice;
  const discount = trans_sku_lists[0]?.discount || null;

  return (
    <div className="relative bg-white block transition duration-300">
      {/* Best Seller Badge */}
      {selling_qty && (
        <div className="absolute left-0 top-0 bg-gradient-to-r pb-1 pl-4 pr-6 bg-[#899b69] text-white text-base font-semibold leading-normal best-seller z-[1]">
          Best Seller
        </div>
      )}

      {/* Wishlist Button */}
      <button
        onClick={() => {
          const isInWishlist = wishListDataSuccess?.some(
            (wishItem) => wishItem.productid === productId
          ) || product?.isLiked || false;
          handleAddToWishlist(
            trans_sku_lists[0]?.generatedSku,
            product.productId,
            isInWishlist
          );
        }}
        className="absolute top-2 right-2 text-white hover:text-red-500 focus:outline-none transition-colors duration-300 z-[1]"
        aria-label="Add to Wishlist"
      >
        <img
          src={
            (wishListDataSuccess?.some(
              (wishItem) => wishItem.productid === productId
            ) || product?.isLiked)
              ? constants.DEFAULT_IMAGE + "/heart-filled.svg"
              : constants.DEFAULT_IMAGE + "/heart-outline.svg"
          }
          alt="Wishlist"
          className="w-5 h-5 transition-all duration-300"
        />
      </button>

      {/* Product Image and Details */}
      <Link to={productUrl} className="block mb-2">
        <div
          className="w-full overflow-hidden relative group"
          onMouseEnter={() => setHoveredProductId(product.productId)}
          onMouseLeave={() => setHoveredProductId(null)}
        >
          <img
            src={getImage(productImage, "700X700")}
            alt={productName}
            className="w-full h-full object-cover transition-all duration-500 ease-in-out group-hover:opacity-0 group-hover:scale-105"
          />
          <img
            src={getImage(productImage2, "700X700")}
            alt={productName}
            className="w-full h-full object-cover absolute inset-0 opacity-0 scale-95 transition-all duration-500 ease-in-out group-hover:opacity-100 group-hover:scale-100"
          />
        </div>
        <h3 className="text-base leading-5 font-medium text-center mt-1">
          {descriptionShow(productName)}
        </h3>
        <p className="text-[#676767] text-center font-medium text-sm">
          {sellingPrice !== discount_price && (
            <span className="line-through">
              {formatCurrencywithamount(
                discount_price,
                selectedcountrySuccess?.currencyAlias || "",
                selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : "",
                dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
              )}
            </span>
          )}
          &nbsp;
          {formatCurrencywithamount(
            sellingPrice,
            selectedcountrySuccess?.currencyAlias || "",
            selectedcountrySuccess?.iso ? `en-${selectedcountrySuccess?.iso}` : "",
            dailyMetalPriceSuccess?.data?.allMasterCountries?.nodes
          )}
          &nbsp;
          {discount && discount !== "0" && (
            <span>({discount}% - OFF)</span>
          )}
        </p>
      </Link>
    </div>
  );
});

export default ProductList;
